
<style scoped>


</style>


<template>

<div>

the eid show 2018

</div>

</template>


<script>

export default{
    data:function(){
        return {
            
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/eidshow2018/main.vue